var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ConfirmationModal',{attrs:{"title":"Delete tag","disabled":_vm.deleting},on:{"confirm":_vm.deleteTag,"cancel":_vm.onClose}},[_vm._v("\n\t"+_vm._s(_vm.t('mail', 'The tag will be deleted from all messages.'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }